module.exports = __webpack_public_path__ + "img/florais.967b0d6c.jpeg";